import React from "react";
import { observer, inject } from "mobx-react";
import {onAction, onSnapshot} from "mobx-state-tree";
import { observable } from 'mobx';
//import ErrorBoundry from "../ErrorBoundry/ErrorBoundry";
import { Formik, Field, Form, FieldArray } from 'formik';
//import getCropUrl from "../../utils/getCropUrl"
import getBoxPadUrl from "@utils/getBoxPadUrl"
import isRetina from "is-retina"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import OrderLineQuantity from '@components/Order/OrderLineQuantity'
import {QuantityEdit} from "../Products/QuantityEdit";




function Checkbox(props) {
    return (
        <Field name={props.name}>
            {({ field, form }) => {
                //console.log("checkbox", field)
                return (
                    <div className={props.className + " custom-control"}
                        onClick={() => {
                            form.setFieldValue(props.name, !field.value);
                        }}
                    >
                        <input
                            type="checkbox"

                            children={null}
                            checked={field.value}
                            readOnly
                        />
                        <div className="control-indicator"></div>
                        <label
                            className="custom-control-label">
                            {props.children}
                        </label>
                    </div>
                );
            }}
        </Field>
    );
}



@inject("store")
@observer

export default class Checkout extends React.Component {
    @observable EditProduct = [];

    @observable currentOrder = null;
    
    

    constructor(props) {
        super(props);
        this.openProductDialog = this.openProductDialog.bind(this);
        this.closeCart = this.closeCart.bind(this);
        this.toggleProductlineEdit = this.toggleProductLineEdit.bind(this);
        this.removeProduct = this.removeProduct.bind(this);

        this.getPrimaryImageUrl = this.getPrimaryImageUrl.bind(this);
        this.goToPage = this.goToPage.bind(this);

        this.updateQuantity = this.updateQuantity.bind(this);
        this.increaseQuantity = this.increaseQuantity.bind(this);
        this.decreaseQuantity = this.decreaseQuantity.bind(this);

        this.klarnaCheckoutDiv = React.createRef();
        this.renderSnippet = this.renderSnippet.bind(this);
        this.refreshKlarnaSnippet = this.refreshKlarnaSnippet.bind(this);

        this.changeShippingCountry = this.changeShippingCountry.bind(this);
        this.getHandleShippingMethodDescription = this.getHandleShippingMethodDescription.bind(this);

        
        
        this.state = {
            hasPaymentSnippet: true, // default
            activePaymentMethodId: 0,
            checkoutInitialized: false,
            showVoucherInput: false,
            voucherCode: "",
            showNoteInput: (this.props.store.order.activeOrder && this.props.store.order.activeOrder.Note.trim() !== ""),
            note: (this.props.store.order.activeOrder && this.props.store.order.activeOrder.Note) || ""
            
        };
        
        this.handleVoucherToggle = this.handleVoucherToggle.bind(this);
        this.handleVoucherAdd = this.handleVoucherAdd.bind(this);
        this.handleVoucherRemove = this.handleVoucherRemove.bind(this);
        this.handleVoucherChange = this.handleVoucherChange.bind(this);
        this.handleVoucherKeyDown = this.handleVoucherKeyDown.bind(this);

        this.handleNoteToggle = this.handleNoteToggle.bind(this);
        this.handleNoteChange = this.handleNoteChange.bind(this);

        this.handleCheckout = this.handleCheckout.bind(this);
        this.handleKlarnaUpdates = this.handleKlarnaUpdates.bind(this);
        
    }

    getHandleShippingMethodDescription(currentCountryCode, description) {
        if (description.indexOf(":") > 0) {
            if (!currentCountryCode) {
                return "";
            }

            var infoArray = [];
            if (description.indexOf(";") > 0) {
                infoArray = description.split(";");
            } else {
                infoArray.push(description);
            }

            for (var i = 0; i < infoArray.length; i++) {
                var infoSplit = infoArray[i].split(":");
                var countryCodes = "" + infoSplit[0];
                if (countryCodes.toLowerCase().indexOf((""+currentCountryCode).toLowerCase()) > -1) {
                    if (infoSplit.length > 1) {
                        return infoSplit[1];
                    }
                }
            }
            return "";
        }
        return description;
    }

    renderSnippet(htmlSnippet) {
        
        var checkoutContainer = this.klarnaCheckoutDiv.current;
        if (checkoutContainer.innerHTML.length > 0) {
             //console.log("renderSnippet - allready loaded");
             return;
         }
        
        checkoutContainer.innerHTML = htmlSnippet;
        var scriptsTags = checkoutContainer.getElementsByTagName('script');
        // This is necessary otherwise the scripts tags are not going to be evaluated
        for (var i = 0; i < scriptsTags.length; i++) {
            var parentNode = scriptsTags[i].parentNode
            var newScriptTag = document.createElement('script');
            newScriptTag.type = 'text/javascript'
            newScriptTag.text = scriptsTags[i].text;
            parentNode.removeChild(scriptsTags[i]);
            parentNode.appendChild(newScriptTag);
        }
        this.setState({ hasPaymentSnippet: true });
    }

    clearSnippet() {
        const checkoutContainer = this.klarnaCheckoutDiv.current;
        if (checkoutContainer) {
            checkoutContainer.innerHTML = null;
            this.setState({ hasPaymentSnippet: false });
        }
    }
    
    handleKlarnaUpdates(call) {
        
        if(!window._klarnaCheckout) return;
        
        switch(call.name) {
            case "updateQuantities":
            case "update":
                window._klarnaCheckout(api => {api.suspend();})
                break;
            case "setBasket":
                 window._klarnaCheckout(api => {api.suspend(); api.resume();})
        }
        
    }

    componentDidMount() {
        if (typeof window === 'undefined') return;

        this.onActionDisposer = onAction(this.props.store.order, call => {
            //console.log(call);
            this.handleKlarnaUpdates(call)
        }, true); // Attach after action has run

        // start checkout
        if (!this.props.store.order.activeOrder) return;
        
        this.setState({ checkoutInitialized: true });
        
        this.props.store.analytics.checkout();

        this.props.store.order.activeOrder.startBasketCheckout().then((result) => {
            this.refreshKlarnaSnippet();
            
        });
    }
    
    componentWillUnmount() {
        this.onActionDisposer();
    }


    componentWillReact() {
        const order = this.props.store.order;
        if (typeof window === 'undefined') return;
        //console.log("componentWillReact", order && order.activeOrder.OrderPropertyByKey("$KlarnaSnippet"));

        if (!this.state.checkoutInitialized && order && order.activeOrder) {
            //console.log("componentWillreact", this.state.checkoutInitialized, this.state.activePaymentMethodId);
            this.setState({ checkoutInitialized: true, activePaymentMethodId: order.activeOrder.PaymentMethodId, note: order.activeOrder.Note, showNoteInput: order.activeOrder.Note.trim() !== "" });
            

            this.props.store.order.activeOrder.startBasketCheckout().then((result) => {
                // order-object might be changed
                if (this.props.store.order.activeOrder &&
                    this.props.store.order.activeOrder.OrderPropertyByKey("$KlarnaSnippet")) {
                    this.renderSnippet(this.props.store.order.activeOrder.OrderPropertyByKey("$KlarnaSnippet"));
                } else {
                    this.clearSnippet();
                }
            });
        }

        
        
    }




    openProductDialog(e, sku) {
        e.preventDefault();
        const navigationStore = this.props.store.navigation;
        navigationStore.openProductDialog(sku);
    }


    toggleProductLineEdit(e, sku) {
        e.preventDefault();
        e.stopPropagation();
        const index = this.EditProduct.indexOf(sku);
        if (index > -1) {
            this.EditProduct = [...this.EditProduct.slice(0, index), ...this.EditProduct.slice(index + 1)];
        } else {
            this.EditProduct.push(sku);
        }
    }

    removeProduct(e, sku, name) {
        e.stopPropagation();
        e.preventDefault();
        const order = this.props.order;

        if (!order) return;
        if (confirm("Are you sure that you want to remove:\n" + name + "\n" + sku)) {
            order.removeProduct(sku).then(res => {
                //success
            },
                err => {
                    alert(err.message);
                });
        }
    }


    getPrimaryImageUrl(orderLine) {
        const retina = isRetina();
        const navigation = this.props.store.navigation;
        const imageWidth = 80 * (retina ? 2 : 1);
        const imageHeight = imageWidth * 1;

        const url = orderLine.PrimaryImageUrl;
        return !url
            ? "/dist/img/no_image.jpg"
            : getBoxPadUrl(url, imageWidth, imageHeight, navigation.ImageFormat, "ffffff").url;
    }

    goToPage(url) {
        this.closeCart();
        const { navigation } = this.props.store;
        navigation.mainRouter.push(url);
    }


    closeCart() {
        const { navigation } = this.props.store;
        navigation.toolbarRouter.push("/");
    }

    updateQuantity(e, product) {
        const newQuantity = e.target.value;
        e.preventDefault();
        
        // const changes = [
        //     {
        //
        //         Sku: product.Sku,
        //         VariantSku: product.VariantSku,
        //         Quantity: newQuantity,
        //         ProductUrl: ""
        //     }
        // ];

        const changes =
            [
                {
                    OrderLineId: -1,
                    Sku: product.Sku,
                    VariantSku: product.VariantSku,
                    OriginalQuantity: newQuantity
                }
            ];
        
        this.props.store.order.updateQuantities(changes);
    }

    increaseQuantity(e, product) {
        e.preventDefault();
        const changes = [
            {

                Sku: product.Sku,
                VariantSku: product.VariantSku,
                Quantity: 1,
                ProductUrl: ""
            }
        ];

        this.props.store.order.increaseQuantities(changes, null);
    }

    decreaseQuantity(e, product) {
        e.preventDefault();
        const changes = [
            {
                Sku: product.Sku,
                VariantSku: product.VariantSku,
                Quantity: -1,
                ProductUrl: ""
            }
        ];
        
        this.props.store.order.increaseQuantities(changes);
    }

    handleVoucherToggle() {
        this.setState({ showVoucherInput: !this.state.showVoucherInput });
    }

    handleNoteToggle() {
        this.setState({ showNoteInput: !this.state.showNoteInput });
    }

    handleVoucherAdd() {
        this.props.store.order.activeOrder.AddVoucherCode(this.state.voucherCode);
        this.setState({ voucherCode: "" });
    }

    handleVoucherRemove(voucherCode) {
        this.props.store.order.activeOrder.RemoveVoucherCode(voucherCode);
    }

    handleVoucherChange(e) {
        this.setState({ voucherCode: e.target.value });
    }

    handleNoteChange(e) {
        this.setState({ note: e.target.value });
    }

    handleVoucherKeyDown(e) {
        if (e.key === 'Enter') {
            this.handleVoucherAdd();
        }
    }

    changeShippingCountry(e) {
        const countryISOCode = e.target.value;
        const navigation = this.props.store.navigation;

        const url = navigation.getUrlFromLocation() + "?switchstore=" + navigation.LanguageCode + "-" + navigation.MarketCode + "&country=" + countryISOCode;
        e.preventDefault();
        window.location = url;
        //this.handleCheckout(null, { countryISOCode });

    }


    async handleCheckout(e, values) {
        return this.props.store.order.update(values).then((result) => {
            this.refreshKlarnaSnippet();
            return result;
        });
    }

    refreshKlarnaSnippet() {
        if (this.props.store.order.activeOrder &&
            this.props.store.order.activeOrder.OrderPropertyByKey("$KlarnaSnippet")) {
            this.renderSnippet(this.props.store.order.activeOrder.OrderPropertyByKey("$KlarnaSnippet"));
            
        } else {
            this.clearSnippet();
        }
    }


    validateCheckout(values) {
        //console.log("validateCheckout", values);


        let errors = {};



        if (!values.billingFirstName) {
            errors.billingFirstName = 'Required';
        }
        if (!values.billingLastName) {
            errors.billingLastName = 'Required';
        }

        if (!values.billingEmailAddress) {
            errors.billingEmailAddress = 'Required';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.billingEmailAddress)) {
            errors.billingEmailAddress = 'Ange en e-postadress';
        }

        if (!values.billingPhoneNumber) {
            errors.billingPhoneNumber = 'Required';
        }

        if (!values.billingCity) {
            errors.billingCity = 'Required';
        }

        if (!values.billingPostalCode) {
            errors.billingPostalCode = 'Required';
        }

        if (!values.billingLine1) {
            errors.billingLine1 = 'Required';
        }

        if (!values.useSameAsBilling) {
            // Validate shipping
            if (!values.shippingFirstName) {
                errors.shippingFirstName = 'Required';
            }
            if (!values.shippingLastName) {
                errors.shippingLastName = 'Required';
            }

            if (!values.shippingPhoneNumber) {
                errors.shippingPhoneNumber = 'Required';
            }

            if (!values.shippingCity) {
                errors.shippingCity = 'Required';
            }

            if (!values.shippingPostalCode) {
                errors.shippingPostalCode = 'Required';
            }

            if (!values.shippingLine1) {
                errors.shippingLine1 = 'Required';
            }
        }

        if (!values.termsAccepted) {
            errors.termsAccepted = "Required";
        }


        //console.log("validateCheckout", values, errors);
        return errors;
    }


    render() {
        const order = this.props.store.order.activeOrder;
        const navigation = this.props.store.navigation;

        if (!order) return (<div></div>);
        
        //console.log("Render", this.state.hasPaymentSnippet)

        const shippingMethod = order.ShippingMethods.find(x => x.ShippingMethodId === order.ShippingMethodId);

        let visibleSection = 1;

        let sortedVisualOrderLines = [];

        if (order && order.ProductList && order.ProductList.length > 0) {
            let visualOrderLines = [];
            order.ProductList.map(product => {
                product.OrderLines.map(orderLine => {
                    visualOrderLines.push(orderLine);
                });
            });

            sortedVisualOrderLines = visualOrderLines.slice().sort(function (a, b) {
                const sortValueA = a.IsGenerated ? 1 : 0;
                const sortValueB = b.IsGenerated ? 1 : 0;

                if (sortValueA < sortValueB) return -1;
                if (sortValueA > sortValueB) return 1;
                return 0;
            });
        }

        const freeShippingInfo = parseFloat(order.FreeShippingInfo);

        return (
            <div className="container-fluid checkout cart-inner">
                {(order == null || sortedVisualOrderLines.length === 0) &&
                    <div className="row">
                        <div className="col-12">
                            <div className="checkout-header"><h2>{navigation.dictionary.Checkout}</h2></div>
                        </div>
                        <div className="col-12">
                            <div className="cart-inner">
                                <div className="cart-content" style={{ border: 0 }}>
                                    <div className="cart-content-inner">
                                        <div className="cart-empty">{this.props.store.navigation.dictionary.YourBasketIsEmpty}  <FontAwesomeIcon icon={["far", "sad-tear"]} className="cart-empty-icon" /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                }
                {order != null && sortedVisualOrderLines.length > 0 &&
                    <div className="row">
                        <div className="col-12">
                            <div className="checkout-header"><h2>{navigation.dictionary.Checkout}</h2></div>
                        </div>

                        <div className="col-12">
                            <div className="checkout-title">
                                <h3>{navigation.dictionary.Basket}</h3></div>
                            <div>
                                {order == null
                                    ? <div className="cart-empty">{this.props.store.navigation.dictionary.YourBasketIsEmpty}  <FontAwesomeIcon icon={["far", "sad-tear"]} className="cart-empty-icon" /></div>
                                    : <React.Fragment>
                                        <div className="cart-content">
                                            <div className="cart-content-header">
                                                <div className="name">Produkt</div>
                                                <div className="price hidden-md-down">À Pris</div>
                                                <div className="sum">Summa</div></div>
                                            <div className="cart-content-inner">
                                                {sortedVisualOrderLines.length > 0 && sortedVisualOrderLines.map(orderLine => {

                                                    const brand = orderLine.PropertyValueByKey("_brand");
                                                    return (
                                                        <div className="orderline" key={orderLine.Sku + "_" + orderLine.VariantSku}>
                                                            <div className="orderline-image"><img alt={orderLine.ProductName} width={80} height={80} src={this.getPrimaryImageUrl(orderLine)} /></div>
                                                            <div className="orderline-text">
                                                                <a href="#" onClick={(e) => this.goToPage(orderLine.ProductUrl)}>
                                                                    <div className="brand"><strong>{brand}</strong></div>
                                                                    {orderLine.ProductName}
                                                                </a>
                                                                {/*{navigation.dictionary.Price}:&nbsp;*/}
                                                                {/*{orderLine.DiscountFormatted.length > 0*/}
                                                                {/*    ?*/}
                                                                {/*    <React.Fragment>*/}
                                                                {/*        <span className="">{orderLine.PriceFormatted} {order.Currency}</span>*/}
                                                                {/*        <div style={{ position: "relative", display: "inline-block" }}><span className="listprice-value">{orderLine.ListPriceFormatted} {order.Currency}</span></div>*/}
                                                                {/*    </React.Fragment>*/}
                                                                {/*    : <React.Fragment>*/}
                                                                {/*        <span className="">{orderLine.PriceFormatted} {order.Currency}</span>*/}
                                                                {/*    </React.Fragment>*/}
                                                                {/*}*/}

                                                                <div className="quantity-and-price-container">
                                                                    <div className="quantity-container basket">
                                                                        
                                                                        <QuantityEdit
                                                                            orderStore={this.props.store.order}
                                                                            key={orderLine.Sku + "_" + orderLine.VariantSku}
                                                                            sku={orderLine.Sku}
                                                                            variantSku={orderLine.VariantSku}
                                                                            quantity={orderLine.Quantity}
                                                                            increments={1}
                                                                        />
                                                                    </div>

                                                                    <div className="orderline-price hidden-md-down">
                                                                        {orderLine.DiscountFormatted.length > 0
                                                                            ? <span className="listprice-value">{
                                                                                orderLine.ListPriceFormatted} {order.Currency}</span>
                                                                            : null}
                                                                        <span className={orderLine.DiscountFormatted.length > 0 ? "discount-price" : ""}>
                                                        {orderLine.TotalFormatted === "N/A"
                                                            ? 0
                                                            : orderLine.PriceFormatted} {order.Currency}
                                                            </span>
                                                                    </div>


                                                                    <div className="orderline-price">
                                                        <span className={orderLine.DiscountFormatted.length > 0 ? "discount-price" : ""}>
                                                        {orderLine.TotalFormatted === "N/A"
                                                            ? 0
                                                            : orderLine.TotalFormatted} {order.Currency}
                                                            </span>
                                                                    </div>


                                                                </div>
                                                            </div>
                                                            <div className="remove-orderline">
                                                                <FontAwesomeIcon icon={["fas", "trash"]} className="remove-orderline-button" onClick={(e) => {
                                                                    e.target.value = 0;
                                                                    this.updateQuantity(e, orderLine);
                                                                }} />
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                                {sortedVisualOrderLines.length === 0 && <div className="cart-empty">{this.props.store.navigation.dictionary.YourBasketIsEmpty}  <FontAwesomeIcon icon={["far", "sad-tear"]} className="cart-empty-icon" /></div>}
                                            </div>

                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 col-12">
                                                {!this.state.showVoucherInput ? <a className="voucher-link" href="javascript:void(0)" onClick={(e) => this.handleVoucherToggle()}>{navigation.dictionary.HaveVoucher}</a> :
                                                <div className="form-group has-float-label"><label className="control-label">Rabattkod</label>
                                                    <div className="input-group-checkout">
                                                        <input type="text" className="discount form-control"
                                                           value={this.state.voucherCode} placeholder={this.props.store.navigation.dictionary.EnterVoucherCode} onChange={this.handleVoucherChange}
                                                           onKeyUp={this.handleVoucherKeyDown}   
                                                        />
                                                        <span className="input-group-btn">
                                                            <button  className="btn btn-secondary btn-sm"
                                                                onClick={(e) => this.handleVoucherAdd()}>{navigation.dictionary.AddTo}</button>
                                                        </span></div>
                                                </div>}
                                                {/*<a className="voucher-link" href="javascript:void(0)" onClick={(e) => this.handleNoteToggle()}>{navigation.dictionary.AddNote || "Jag vill ange ett meddelande"}</a> */}
                                                <div className="form-group has-float-label"><label className="control-label">Meddelande</label>
                                                    <textarea rows="3" cols="20" 
                                                              value={this.state.note}
                                                              className="message form-control input-checkout"
                                                              placeholder={this.props.store.navigation.dictionary.EnterNote || "Skriv meddelande"}
                                                              onChange={this.handleNoteChange}
                                                              onBlur={e => { this.handleCheckout(e, { note: this.state.note })}}
                                                          ></textarea>
                                                </div>

                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="cart-footer">
                                                    {order.ProductList && order.ProductList.length > 0 ?
                                                        <React.Fragment>

                                                            <dl className="cart-order-totals">
                                                                {order.Vouchers.length !== 0 &&
                                                                    <React.Fragment>
                                                                        <dt>
                                                                            <strong>{this.props.store.navigation.dictionary.Discounts}</strong><br/>
                                                                            {order.Vouchers.map((voucher) => {
                                                                                return (
                                                                                    <React.Fragment key={voucher}>
                                                                                        <span className="text-xs">{voucher}</span><span className="text-xs voucher-code-remove"
                                                                                                                                        onClick={(e) => this.handleVoucherRemove(voucher)}>{this.props.store.navigation.dictionary.Remove}</span><br/>
                                                                                    </React.Fragment>
                                                                                );
                                                                            })}
                                                                </dt>
                                                                <dd>{order.DiscountTotalWithVATFormatted === "0.00" || order.DiscountTotalWithVATFormatted === "0,00" ? 0 : "-" + order.DiscountTotalWithVATFormatted} {order.Currency}</dd>

                                                            </React.Fragment>}
                                                        
                                                        <dt>
                                                            {shippingMethod && <React.Fragment>
                                                                {navigation.dictionary.Shipping}
                                                            </React.Fragment>}
                                                        </dt>
                                                        
                                                        <dd>
                                                            {order.ShipmentPrice !== order.ShippingTotal
                                                            ? <React.Fragment> 
                                                                <span className="discount-price">{order.ShippingTotalFormatted} {order.Currency}</span><span className="listprice-value">{order.ShipmentPriceFormatted} {order.Currency}</span>
                                                            </React.Fragment>
                                                            : <React.Fragment>
                                                                {order.ShippingTotalFormatted} {order.Currency}
                                                            </React.Fragment>}
                                                        </dd>
                                                        
                                                        <dd className="free-shipping-info">
                                                            {freeShippingInfo > 0 && order.ShippingTotal > 0 
                                                                ? <React.Fragment> 
                                                                    <span className="free-shipping-info left">{this.props.store.navigation.dictionary.FreeShippingInfo.replace("{0}", order.FreeShippingInfo)}</span>
                                                                </React.Fragment>
                                                                : freeShippingInfo === 0 && <React.Fragment>
                                                                    <span className="free-shipping-info free">{this.props.store.navigation.dictionary.FreeShipping}</span>
                                                                </React.Fragment> }
                                                        </dd>

                                                        <dt className="cart-sum-total">{this.props.store.navigation.dictionary.TotalInclTax}</dt>
                                                        <dd className="cart-sum-total"><strong>{order.OrderTotalFormatted === "0.00" || order.OrderTotalFormatted === "0,00" ? 0 : order.OrderTotalFormatted} {order.Currency}</strong><br />
                                                            <span className="vat-info">{this.props.store.navigation.dictionary.VatTotal} {order.TaxTotal > 0 ? order.TaxTotalFormatted : 0} {order.Currency}</span></dd>
                                                    </dl>

                                                </React.Fragment>
                                                : null}
                                        </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                }

                            </div>

                        </div>

                        <div className="col-12">
                            <div className="checkout-section checkout-shipping-methods">
                                <div className="checkout-title"><h3>{navigation.dictionary.ShippingMethod}</h3></div>
                                <div className="checkout-indent">
                                    {order.ShippingCountries.length > 1 &&
                                        <div className="row">
                                            <div className="col-12">

                                                <div className="select">
                                                    <select
                                                        value={order.ShippingAddress.CountryISOCode.toLowerCase()}
                                                        onChange={this.changeShippingCountry}

                                                    >
                                                        {order.ShippingCountries.map(country => {
                                                            return (<option key={country.CountryCode}
                                                                value={country.CountryCode}>{country.CountryName}</option>);
                                                        })}
                                                    </select>
                                                    <div className="white-arrow"></div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <div className="row">

                                        {order.ShippingMethods.map(shippingMethod => {
                                            return (
                                                <React.Fragment key={shippingMethod.ShippingMethodId}>
                                                    <div className="col-12">
                                                        <label className="control-radio">
                                                            <input type="radio" className=""
                                                                value={shippingMethod.ShippingMethodId}
                                                                checked={order.ShippingMethodId === shippingMethod.ShippingMethodId}
                                                                onChange={e => { this.handleCheckout(e, { shippingMethod: shippingMethod }) }}
                                                            />


                                                            <div className="control-indicator" style={{ visibility: (order.ShippingMethods.length === 1 ? "hidden" : "visible") }}
                                                            />
                                                            <div className="control-content" style={{ marginLeft: (order.ShippingMethods.length === 1 ? "0px" : "") }}>
                                                                {shippingMethod.ImageUrl
                                                                    ? <img className="control-image" src={shippingMethod.ImageUrl} />
                                                                    : <h4>{shippingMethod.DisplayName}</h4>
                                                                }
                                                                <span className="checkout-shipping-price">({shippingMethod.PriceWithTaxFormatted} {order.Currency})</span>
                                                                {this.getHandleShippingMethodDescription(navigation.CountryCode, shippingMethod.Description)}
                                                            </div>
                                                        </label>
                                                    </div>

                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="checkout-section checkout-payment-methods">
                                <div className="checkout-title"><h3>{navigation.dictionary.PaymentMethod}</h3></div>
                                <div className="checkout-indent">
                                    {order.PaymentMethods.map(paymentMethod => {
                                        return (
                                            <div className="row mb-1x" key={paymentMethod.PaymentMethodId}>
                                                <div className="col-12">
                                                    <label className="control-radio">
                                                        <input type="radio" className=""
                                                            value={paymentMethod.PaymentMethodId}
                                                            checked={order.PaymentMethodId === paymentMethod.PaymentMethodId}
                                                            onChange={e => { this.handleCheckout(e, { paymentMethod: paymentMethod }) }}
                                                        />
                                                        <div className="control-indicator" />
                                                        <div className="control-content">
                                                            {paymentMethod.ImageUrl
                                                                ? <img src={paymentMethod.ImageUrl} />
                                                                : <h4>{paymentMethod.DisplayName}</h4>
                                                            }
                                                            {paymentMethod.Description}
                                                        </div>
                                                    </label>
                                                </div>

                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>


                        <React.Fragment>
                            {!this.state.hasPaymentSnippet && order.PaymentMethodId > 0 && order.BillingAddress &&

                                <Formik
                                    countryName={order.BillingAddress.CountryName}
                                    state={this.state}
                                    initialValues={{
                                        billingFirstName: order.BillingAddress.FirstName,
                                        billingLastName: order.BillingAddress.LastName,
                                        billingEmailAddress: order.BillingAddress.EmailAddress,
                                        billingPhoneNumber: order.BillingAddress.PhoneNumber,
                                        billingCompany: order.BillingAddress.Company,
                                        billingLine1: order.BillingAddress.Line1,
                                        billingLine2: order.BillingAddress.Line2,
                                        billingPostalCode: order.BillingAddress.PostalCode,
                                        billingCity: order.BillingAddress.City,
                                        billingCountryName: order.BillingAddress.CountryName,

                                        useSameAsBilling: true,
                                        termsAccepted: false,

                                        shippingFirstName: order.ShippingAddress.FirstName,
                                        shippingLastName: order.ShippingAddress.LastName,
                                        shippingEmailAddress: order.ShippingAddress.EmailAddress,
                                        shippingPhoneNumber: order.ShippingAddress.PhoneNumber,
                                        shippingCompany: order.ShippingAddress.Company,
                                        shippingLine1: order.ShippingAddress.Line1,
                                        shippingLine2: order.ShippingAddress.Line2,
                                        shippingPostalCode: order.ShippingAddress.PostalCode,
                                        shippingCity: order.ShippingAddress.City,
                                        shippingCountryName: order.ShippingAddress.CountryName,

                                        newsletterTags: []

                                    }}
                                    validate={this.validateCheckout}
                                    onSubmit={(values, actions, resetForm) => {
                                        actions.setStatus({ submitting: true, sent: false });
                                        //this.resetButtonSubmitted = true;

                                        const billingAddress = {
                                            FirstName: values.billingFirstName,
                                            LastName: values.billingLastName,
                                            EmailAddress: values.billingEmailAddress,
                                            PhoneNumber: values.billingPhoneNumber,
                                            Company: values.billingCompany,
                                            Line1: values.billingLine1,
                                            Line2: values.billingLine2,
                                            PostalCode: values.billingPostalCode,
                                            City: values.billingCity

                                        }

                                        this.handleCheckout(null,
                                            {
                                                billingAddress: billingAddress,
                                                shippingAddress: values.useSameAsBilling ? billingAddress : {
                                                    FirstName: values.shippingFirstName,
                                                    LastName: values.shippingLastName,
                                                    EmailAddress: values.shippingEmailAddress,
                                                    PhoneNumber: values.shippingPhoneNumber,
                                                    Company: values.shippingCompany,
                                                    Line1: values.shippingLine1,
                                                    Line2: values.shippingLine2,
                                                    PostalCode: values.shippingPostalCode,
                                                    City: values.shippingCity
                                                },
                                                termsAccepted: values.termsAccepted,
                                                additionalData: { NewsletterTags: values.newsletterTags },
                                                pay: true
                                            }).then((result) => {

                                                if (result.RedirectUrl) {
                                                    window.location.href = result.RedirectUrl;
                                                }
                                                else {
                                                    // todo: felhantering
                                                    actions.setStatus({ submitting: false });
                                                }
                                            });

                                        //this.props.store.account.startPasswordReset(values).then(
                                        //	status => {
                                        //		console.debug(status);
                                        //		actions.setSubmitting(false);
                                        //		actions.setStatus({ submitting: false, sent: true });
                                        //		setTimeout(() => { actions.resetForm(); }, 5000);
                                        //	},
                                        //	error => {
                                        //		console.debug(error);
                                        //		actions.setFieldError("custom", error.messages[0]);
                                        //		actions.setSubmitting(false);

                                        //		actions.setStatus({ submitting: false, sent: false });
                                        //	}
                                        //);
                                    }}>
                                    {/*render={({ values, errors, touched, isSubmitting, isValid, status }) =>*/}

                                        
                                    {
                                        ({ values, errors, touched, isSubmitting, isValid, status }) =>  {

                                        let formVisibleSection = visibleSection;

                                        return (

                                            <div className="col-12">
                                                <Form id="address-form" className="checkout-section checkout-customer-info">
                                                    <div className="checkout-title"><h3>{navigation.dictionary.CustomerInfo}</h3></div>
                                                    <div className="checkout-indent">
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <div className={"form-group " + (touched.billingEmailAddress && errors.billingEmailAddress ? "has-danger" : "")} >
                                                                    <label htmlFor="checkout-email">E-mail Address</label>
                                                                    <Field className="form-control" name="billingEmailAddress" type="email" placeholder="" />
                                                                    {errors.billingEmailAddress &&
                                                                        touched.billingEmailAddress &&
                                                                        <div className="form-control-feedback">{errors.billingEmailAddress}</div>}
                                                                </div>
                                                            </div>

                                                        </div>

                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <div className={"form-group " + (touched.billingFirstName && errors.billingFirstName ? "has-danger" : "")} >
                                                                    <label htmlFor="checkout-fn">{navigation.dictionary.FirstName}</label>
                                                                    <Field className="form-control" name="billingFirstName" type="text" placeholder="" />
                                                                    {errors.billingFirstName &&
                                                                        touched.billingFirstName &&
                                                                        <div className="form-control-feedback">{errors.billingFirstName}</div>}
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className={"form-group " + (touched.billingLastName && errors.billingLastName ? "has-danger" : "")} >
                                                                    <label htmlFor="checkout-ln">{navigation.dictionary.LastName}</label>
                                                                    <Field className="form-control" name="billingLastName" type="text" placeholder="" />
                                                                    {errors.billingLastName &&
                                                                        touched.billingLastName &&
                                                                        <div className="form-control-feedback">{errors.billingLastName}</div>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">

                                                            <div className="col-sm-6">
                                                                <div className={"form-group " + (touched.billingPhoneNumber && errors.billingPhoneNumber ? "has-danger" : "")} >
                                                                    <label htmlFor="checkout-phone">{navigation.dictionary.PhoneNumber}</label>
                                                                    <Field className="form-control" name="billingPhoneNumber" type="text" placeholder="" />
                                                                    {errors.billingPhoneNumber &&
                                                                        touched.billingPhoneNumber &&
                                                                        <div className="form-control-feedback">{errors.billingPhoneNumber}</div>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <div className={"form-group " + (touched.billingLine1 && errors.billingLine1 ? "has-danger" : "")} >
                                                                    <label htmlFor="checkout-address1">{navigation.dictionary.Address1}</label>
                                                                    <Field className="form-control" name="billingLine1" type="text" placeholder="" />
                                                                    {errors.billingLine1 &&
                                                                        touched.billingLine1 &&
                                                                        <div className="form-control-feedback">{errors.billingLine1}</div>}
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className={"form-group " + (touched.billingLine2 && errors.billingLine2 ? "has-danger" : "")} >
                                                                    <label htmlFor="checkout-address2">{navigation.dictionary.Address2}</label>
                                                                    <Field className="form-control" name="billingLine2" type="text" placeholder="" />
                                                                    {errors.billingLine2 &&
                                                                        touched.billingLine2 &&
                                                                        <div className="form-control-feedback">{errors.billingLine2}</div>}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <div className={"form-group " + (touched.billingCity && errors.billingCity ? "has-danger" : "")} >
                                                                    <label htmlFor="checkout-city">{navigation.dictionary.City}</label>
                                                                    <Field className="form-control" name="billingCity" type="text" placeholder="" />
                                                                    {errors.billingCity &&
                                                                        touched.billingCity &&
                                                                        <div className="form-control-feedback">{errors.billingCity}</div>}
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className={"form-group " + (touched.billingPostalCode && errors.billingPostalCode ? "has-danger" : "")} >
                                                                    <label htmlFor="checkout-zip">{navigation.dictionary.ZipCode}</label>
                                                                    <Field className="form-control" name="billingPostalCode" type="text" placeholder="" />
                                                                    {errors.billingPostalCode &&
                                                                        touched.billingPostalCode &&
                                                                        <div className="form-control-feedback">{errors.billingPostalCode}</div>}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row padding-bottom-1x">
                                                            <div className="col-sm-12">
                                                                <div className="form-group">
                                                                    <label htmlFor="checkout-country">{navigation.dictionary.Country}</label>
                                                                    <Field className="form-control" name="billingCountryName" type="text" placeholder="" readOnly={true} />
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="form-group margin-bottom-3x">

                                                            <Checkbox className="control-checkbox" name="useSameAsBilling" >{navigation.dictionary.ShipToSameAddress}</Checkbox>
                                                        </div>
                                                    </div>

                                                    {!values.useSameAsBilling &&

                                                        <React.Fragment>
                                                            <div className="checkout-title"><h3>{navigation.dictionary.ShippingAddress}</h3></div>
                                                            <div className="checkout-indent">
                                                                <div className="row">


                                                                    <div className="col-sm-6">
                                                                        <div className={"form-group " + (touched.shippingFirstName && errors.shippingFirstName ? "has-danger" : "")} >
                                                                            <label htmlFor="checkout-fn">{navigation.dictionary.FirstName}</label>
                                                                            <Field className="form-control" name="shippingFirstName" type="text" placeholder="" />
                                                                            {errors.shippingFirstName &&
                                                                                touched.shippingFirstName &&
                                                                                <div className="form-control-feedback">{errors.shippingFirstName}</div>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <div className={"form-group " + (touched.shippingLastName && errors.shippingLastName ? "has-danger" : "")} >
                                                                            <label htmlFor="checkout-ln">{navigation.dictionary.LastName}</label>
                                                                            <Field className="form-control" name="shippingLastName" type="text" placeholder="" />
                                                                            {errors.shippingLastName &&
                                                                                touched.shippingLastName &&
                                                                                <div className="form-control-feedback">{errors.shippingLastName}</div>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">

                                                                    <div className="col-sm-6">
                                                                        <div className={"form-group " + (touched.shippingPhoneNumber && errors.shippingPhoneNumber ? "has-danger" : "")} >
                                                                            <label htmlFor="checkout-phone">{navigation.dictionary.PhoneNumber}</label>
                                                                            <Field className="form-control" name="shippingPhoneNumber" type="text" placeholder="" />
                                                                            {errors.shippingPhoneNumber &&
                                                                                touched.shippingPhoneNumber &&
                                                                                <div className="form-control-feedback">{errors.shippingPhoneNumber}</div>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-sm-6">
                                                                        <div className={"form-group " + (touched.shippingLine1 && errors.shippingLine1 ? "has-danger" : "")} >
                                                                            <label htmlFor="checkout-address1">{navigation.dictionary.Address1}</label>
                                                                            <Field className="form-control" name="shippingLine1" type="text" placeholder="" />
                                                                            {errors.shippingLine1 &&
                                                                                touched.shippingLine1 &&
                                                                                <div className="form-control-feedback">{errors.shippingLine1}</div>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <div className={"form-group " + (touched.shippingLine2 && errors.shippingLine2 ? "has-danger" : "")} >
                                                                            <label htmlFor="checkout-address2">{navigation.dictionary.Address2}</label>
                                                                            <Field className="form-control" name="shippingLine2" type="text" placeholder="" />
                                                                            {errors.shippingLine2 &&
                                                                                touched.shippingLine2 &&
                                                                                <div className="form-control-feedback">{errors.shippingLine2}</div>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-sm-6">
                                                                        <div className={"form-group " + (touched.shippingCity && errors.shippingCity ? "has-danger" : "")} >
                                                                            <label htmlFor="checkout-city">{navigation.dictionary.City}</label>
                                                                            <Field className="form-control" name="shippingCity" type="text" placeholder="" />
                                                                            {errors.shippingCity &&
                                                                                touched.shippingCity &&
                                                                                <div className="form-control-feedback">{errors.shippingCity}</div>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <div className={"form-group " + (touched.shippingPostalCode && errors.shippingPostalCode ? "has-danger" : "")} >
                                                                            <label htmlFor="checkout-zip">{navigation.dictionary.ZipCode}</label>
                                                                            <Field className="form-control" name="shippingPostalCode" type="text" placeholder="" />
                                                                            {errors.shippingPostalCode &&
                                                                                touched.shippingPostalCode &&
                                                                                <div className="form-control-feedback">{errors.shippingPostalCode}</div>}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="row padding-bottom-1x">
                                                                    <div className="col-sm-12">
                                                                        <div className="form-group">
                                                                            <label htmlFor="checkout-country">{navigation.dictionary.Country}</label>
                                                                            <Field className="form-control" name="shippingCountryName" type="text" placeholder="" readOnly={true} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </React.Fragment>
                                                    }
                                                    {(navigation.mainTree.CurrentCountry.NewsletterTags && navigation.mainTree.CurrentCountry.NewsletterTags.length > 0) &&
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div className="checkout-title"><h3>{navigation.dictionary.NewsletterSignupHeader}</h3></div>
                                                                <div className="checkout-indent">
                                                                    <p>{navigation.dictionary.NewsletterSignupText}</p>
                                                                    <div className={"form-group"} >

                                                                        <FieldArray
                                                                            name="newsletterTags"
                                                                            render={arrayHelpers => (
                                                                                <div>
                                                                                    {navigation.mainTree.CurrentCountry.NewsletterTags.map(tag => (
                                                                                        <div className={"control-checkbox custom-control"} key={tag.Alias}>
                                                                                            <label className="custom-control-label">
                                                                                                <input
                                                                                                    name="newsletterTags"
                                                                                                    type="checkbox"
                                                                                                    value={tag.Alias}
                                                                                                    checked={values.newsletterTags.includes(tag.Alias)}
                                                                                                    onChange={e => {
                                                                                                        if (e.target.checked) arrayHelpers.push(tag.Alias);
                                                                                                        else {
                                                                                                            const idx = values.newsletterTags.indexOf(tag.Alias);
                                                                                                            arrayHelpers.remove(idx);
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                                <div className="control-indicator"></div>
                                                                                                {tag.Name}
                                                                                            </label>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>}



                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="checkout-title"><h3>{navigation.dictionary.ConfirmOrder}</h3></div>
                                                            <div className="checkout-indent">
                                                                <div className={"form-group " + (touched.termsAccepted && errors.termsAccepted ? "has-danger" : "") + " " + (touched.termsAccepted && !errors.termsAccepted ? "has-success" : "")} >
                                                                    <div className="form-group margin-bottom-3x">
                                                                        <Checkbox className="control-checkbox" name="termsAccepted" >{navigation.dictionary.IHaveReadAndAccept}  </Checkbox><a href={navigation.marketSettings.TermsUrl} target="_blank">{navigation.dictionary.GeneralTerms}  </a>
                                                                    </div>

                                                                </div>
                                                                <div className="checkout-footer">
                                                                    {order.ProductList && order.ProductList.length > 0 ?
                                                                        <React.Fragment>
                                                                            <dl className="cart-order-totals">
                                                                                {order.DiscountTotalFormatted !== "" && order.DiscountTotalFormatted !== "0.00" && order.DiscountTotalFormatted !== "0,00" &&
                                                                                    <React.Fragment>
                                                                                        <dt>
                                                                                            <strong>{this.props.store.navigation.dictionary.Discounts}</strong><br />
                                                                                            {order.Vouchers.map((voucher) => {
                                                                                                return (
                                                                                                    <React.Fragment key={voucher}>
                                                                                                        <span className="text-xs">{voucher}</span><span className="text-xs voucher-code-remove" onClick={(e) => this.handleVoucherRemove(voucher)}>{this.props.store.navigation.dictionary.Remove}</span><br />
                                                                                                    </React.Fragment>
                                                                                                );
                                                                                            })}
                                                                                        </dt>
                                                                                        <dd>{order.DiscountTotalFormatted === "0.00" || order.DiscountTotalFormatted === "0,00" ? 0 : "-" + order.DiscountTotalFormatted} {order.Currency}</dd>
                                                                                    </React.Fragment>}
                                                                                <dt>
                                                                                    {shippingMethod && <React.Fragment>
                                                                                        <strong>{navigation.dictionary.Shipping}</strong>
                                                                                    </React.Fragment>}
                                                                                </dt>
                                                                                <dd>{order.ShippingTotalFormatted} {order.Currency}<br /> <span className={"free-shipping-info " + (parseFloat(order.FreeShippingInfo) > 0 ? "left" : "free")}>{parseFloat(order.FreeShippingInfo) > 0 ? this.props.store.navigation.dictionary.FreeShippingInfo.replace("{0}", order.FreeShippingInfo) : this.props.store.navigation.dictionary.FreeShipping}</span>
                                                                                </dd>

                                                                                <dt className="cart-title-total">{this.props.store.navigation.dictionary.TotalInclTax}</dt>
                                                                                <dd className="cart-sum-total">{order.OrderTotalFormatted === "0.00" || order.OrderTotalFormatted === "0,00" ? 0 : order.OrderTotalFormatted} {order.Currency} <br /><span className="vat-info">{this.props.store.navigation.dictionary.VatTotal} {order.TaxTotal > 0 ? order.TaxTotalFormatted : 0} {order.Currency}</span></dd>
                                                                            </dl>

                                                                        </React.Fragment>
                                                                        : null}
                                                                </div>
                                                                <button className="btn btn-success btn-block btn-checkout" type="submit" disabled={!isValid || (status && (status.sent || status.submitting))} >
                                                                    {status && status.submitting ? <span>*{navigation.dictionary.Redirecting}...*</span> : null}
                                                                    {!status || (!status.sent && !status.submitting) ? <span>{navigation.dictionary.PayAndSendOrder}</span> : null}
                                                                </button>

                                                                {errors.custom && <div>{errors.custom}</div>}
                                                            </div>



                                                        </div>
                                                    </div>

                                                    {/*<pre>{JSON.stringify(values, null, 2)}</pre>*/}
                                                </Form>
                                            </div>
                                        );
                                    }}
                                </Formik>
                            }


                            <div className="col-12">
                                <div className="checkout-section ">
                                    {this.state.hasPaymentSnippet && <div className="checkout-title"><h3>Betalning Klarna</h3></div>}
                                
                                {/*{order.ProductList && order.ProductList.length > 0 && <div ref={this.klarnaCheckoutDiv}/>}*/}
                                     <div ref={this.klarnaCheckoutDiv}/>
                                    
                                </div>
                            </div>
                            
                            
                        </React.Fragment>
                    </div >
                }
            </div >
        );
    }
}


const DisplayFormikState = props => (
    <div style={{ margin: '1rem 0' }}>
        <h3 style={{ fontFamily: 'monospace' }} />
        <pre
            style={{
                background: '#f6f8fa',
                fontSize: '.65rem',
                padding: '.5rem',
            }}
        >
            <strong>props</strong> ={' '}
            {JSON.stringify(props, null, 2)}
        </pre>
    </div>
);